import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import WhatsappCampaignsListPage from "./WhatsappCampaignsListPage";
import AdOriginsPage from "./AdOriginsPage";

/**
 * Hub de Campanhas: envio ativo + origem de anúncios (Meta CTWA / Google mensagem).
 */
export default function CampaignsListPage() {
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, pb: { xs: 4, md: 5 }, maxWidth: 1400, mx: "auto" }}>
      <Box sx={{ mb: 2, maxWidth: { md: "46rem" } }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
          Campanhas
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1, lineHeight: 1.65 }}>
          Dispare mensagens para a base ou acompanhe conversas que nasceram de anúncios no WhatsApp.
        </Typography>
      </Box>

      <Tabs
        value={tab}
        onChange={(_e, value) => setTab(value)}
        sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="Envio ativo" />
        <Tab label="Origem de anúncios" />
      </Tabs>

      {tab === 0 ? (
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, maxWidth: 640, lineHeight: 1.55 }}>
            Escolha o canal, o template, o público e dispare agora ou agende. Acompanhe enviado,
            entregue, lido, respondido e falhas na própria campanha.
          </Typography>
          <WhatsappCampaignsListPage embedded />
        </Box>
      ) : (
        <AdOriginsPage />
      )}
    </Box>
  );
}
